import React from 'react';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import BtnWhiteBlackBorderSmallSize from 'app/Components/Shared/Buttons/BtnWhiteBlackBorderSmallSize';
import ContactUsAction from 'app/Components/Shared/ContactUs/ContactUsAction';
import {BanPaymentDataType, isBanUpdatePaymentButtonPrimary, getBanPaymentMethodDisplayParts} from '../../Constants/banPaymentDataTypeEnum';
import {contactUsEnergy, contactUsEnergyMob} from '../../Constants/debtPaymentEnum';
import {useBanUpdatePaymentClick} from '../../hooks/useBanUpdatePaymentClick';
import {isMobile} from 'react-device-detect';
import Image from 'app/Components/Shared/Image/image';

const creditCardIcon = require('../../images/credit_card.svg');
const bankObligationIcon = require('../../images/bank.svg');

const BanPaymentMethodRow = ({banData}) => {
  const label = getBanPaymentMethodDisplayParts(banData.paymentData);
  const usePrimary = isBanUpdatePaymentButtonPrimary(banData);
  const paymentType = banData.paymentData?.paymentType;
  const iconSrc = () => {
    if (paymentType === BanPaymentDataType.CREDIT_CARD) {
      return creditCardIcon;
    } else if (paymentType === BanPaymentDataType.BANK) {
      return bankObligationIcon;
    } else {
      return '';
    }
  };

  const onUpdatePaymentClick = useBanUpdatePaymentClick(banData);

  return (
    <div className='ban-payment-method-row'>
      <div className='ban-payment-method-row__details'>
        {iconSrc() && <Image src={iconSrc()} alt='' className='ban-payment-method-row__icon' />}
        <span className='ban-payment-method-row__label'>{label}</span>
      </div>
      {banData.isEnergy ? (
        <div className='ban-payment-method-row__btn energy'>
          <ContactUsAction contentData={isMobile ? contactUsEnergyMob : contactUsEnergy} />
        </div>
      ) : usePrimary ? (
        <div className='ban-payment-method-row__btn'>
          <BtnSubmit text='לעדכון' onclick={onUpdatePaymentClick} type='button' />
        </div>
      ) : (
        <div className='ban-payment-method-row__btn'>
          <BtnWhiteBlackBorderSmallSize text='לעדכון' onclick={onUpdatePaymentClick} />
        </div>
      )}
    </div>
  );
};

export default BanPaymentMethodRow;
